import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { collaboratorSummaryShape } from 'Workspace/types/collaborator';
import enhanceWithImmutable from '../../../hocs/enhanceWithImmutable';

class CollaboratorsSummaryProvider extends React.Component {
  static defaultProps = {
    limit: 3,
  };

  componentDidMount() {
    const { id, limit } = this.props;

    this.props.getCollaborators(id, limit);
  }

  render() {
    const { collaborators } = this.props;

    return (
      <React.Fragment>
        {this.props.render(collaborators)}
      </React.Fragment>
    );
  }
}

CollaboratorsSummaryProvider.propTypes = {
  id: PropTypes.string.isRequired,
  limit: PropTypes.number,
  collaborators: collaboratorSummaryShape,
  getCollaborators: PropTypes.func.isRequired,
  render: PropTypes.func,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getCollaborators: (id, limit) => dispatch(ownProps.fetchCollaboratorsCommand(id, limit)),
});

const mapStateToProps = (state, ownProps) => ({
  collaborators: ownProps.collaboratorsSelector(state, ownProps.id),
});

export default connect(mapStateToProps, mapDispatchToProps)(enhanceWithImmutable(CollaboratorsSummaryProvider));
